import { Text } from '@chakra-ui/react';
import CurrencyLib from 'currency.js';
import React from 'react';
import CanopyTooltip from '../../CanopyTooltip/CanopyTooltip';
export default function CurrencyAmount({
    currency = '',
    amount,
    align = 'right',
    percent = false,
    pr,
    ...rest
}: Record<string, string | any>) {
    return amount ? (
        <CanopyTooltip
            label={`${currency} ${
                percent
                    ? `${CurrencyLib(amount, {
                          symbol: '',
                      }).format()}%`
                    : CurrencyLib(amount, {
                          symbol: '',
                      }).format()
            }`}
            textAlign={align}
            {...rest}>
            {`${currency} ${
                percent
                    ? `${CurrencyLib(amount, {
                          symbol: '',
                      }).format()}%`
                    : CurrencyLib(amount, {
                          symbol: '',
                      }).format()
            }`}
        </CanopyTooltip>
    ) : (
        <Text textAlign={align}>-</Text>
    );
}
